import { Outlet } from 'react-router-dom';

import ErrorBoundary from '@app/app/providers/error-boundary';
import { StageLayout } from '@app/app/layouts';

// ErrorBoundary Layout для роутера
export const ErrorBoundaryLayout = () => (
  <ErrorBoundary>
    <Outlet />
  </ErrorBoundary>
);

// Layout components for different variants
export const WorkspaceStageLayout = () => <StageLayout isWorkspaceVariant />;
export const AiChatStageLayout = () => <StageLayout isWorkspaceVariant isAiChatVariant />;
export const AiChatPreviewLayout = () => <StageLayout isWorkspaceVariant isAiChatVariant />;
